import { Flex, Typography } from 'antd'
import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { EXCEPTION_STATUS } from 'src/app/shared/constants/common.constants'
import {
  colorBgInfoBold,
  colorBgErrorBold,
  colorBgErrorHovered,
  colorBgInfoHovered,
  colorBgWarningHovered,
  colorBgWarningBold,
} from 'src/app/themes/primaryThemeDefault'

export interface IStatusTag {
  status: string
}

const StatusTag: React.FC<IStatusTag> = (props) => {
  const { status } = props
  const { t } = useTranslation()

  const getConfig = useCallback(
    (status: string) => {
      switch (status) {
        case EXCEPTION_STATUS.RETURNED:
          return {
            color: colorBgErrorBold,
            backgroundColor: colorBgErrorHovered,
            text: t('QuickExceptionProcessing:label.returned'),
          }
        case EXCEPTION_STATUS.EXCEPTION:
          return {
            color: colorBgWarningBold,
            backgroundColor: colorBgWarningHovered,
            text: t('QuickExceptionProcessing:label.exception'),
          }
        case EXCEPTION_STATUS.PROCESSING:
          return {
            color: '#F8C100',
            backgroundColor: '#FFFAE7',
            text: t('QuickExceptionProcessing:label.processingBySystem'),
          }
        default:
          return {
            backgroundColor: colorBgInfoHovered,
            color: colorBgInfoBold,
            text: t('QuickExceptionProcessing:label.paid'),
          }
      }
    },
    [t],
  )

  const configs = useMemo(() => getConfig(status), [getConfig, status])

  return (
    <Flex
      style={{
        borderRadius: 27,
        padding: '4px 12px',
        backgroundColor: configs.backgroundColor,
        width: 'fit-content',
        alignItems: 'center',
        gap: 4,
      }}
    >
      <div
        style={{
          backgroundColor: configs.color,
          width: 4,
          height: 4,
          borderRadius: 50,
        }}
      />
      <Typography
        style={{
          color: configs.color,
          fontSize: 14,
          fontWeight: 700,
          wordBreak: 'keep-all',
        }}
      >
        {configs.text}
      </Typography>
    </Flex>
  )
}

export default StatusTag
